import React from "react";
import { Box, VStack, Text } from "@chakra-ui/react";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";

interface SavingOverlayProps {
	isShown: boolean;
	message?: string;
}

export const SavingOverlay: React.FC<SavingOverlayProps> = ({
	isShown,
	message = "Saving, please wait...",
}) => {
	if (!isShown) return null;

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			bottom={0}
			bg="rgba(0, 0, 0, 0.75)"
			display="flex"
			alignItems="center"
			justifyContent="center"
			zIndex={9999}
			className="cursor-wait"
		>
			<VStack spacing={6}>
				<LoadingSpinner
					spinnerSize="xl"
					label=""
					className="m-0 p-0"
				/>
				<Text
					color="white"
					fontSize="xl"
					fontWeight="semibold"
				>
					{message}
				</Text>
			</VStack>
		</Box>
	);
};
